import { Box } from '@chakra-ui/react'
import {
	X,
	User,
	Home,
	ShoppingBag,
	LogOut,
	ShoppingCart,
	Percent,
	Dumbbell,
	Shirt,
	Package,
	ClipboardList,
	FileText,
} from 'lucide-react'
import CustomersEntity from '@/entities/api/customers/customer'
import { API_URL } from '@/services/api/keys'
import getInitials from '@/utils/getInitials'
import { Link } from 'react-router-dom'

const MenuRight = ({
	customer,
	onLogout,
	isOpen,
	onClose,
}: {
	customer: CustomersEntity | null
	token: string | null
	onLogout: () => void
	isOpen: boolean
	onClose: () => void
}) => {
	const menuItems = [
		{ icon: Home, label: 'Inicio', href: '/' },
		{ icon: ShoppingCart, label: 'Buscar', href: '/Carrito' },
		{ icon: ShoppingBag, label: 'Compras', href: '/Perfil/compras' },
		{ icon: Percent, label: 'Promociones', href: '/Promociones' },
		{ icon: User, label: 'Perfil', href: '/Perfil/informacion' },
		{ icon: Dumbbell, label: 'Suplementos', href: '/Categoria/suplementos' },
		// { icon: Shirt, label: 'Ropa Deportiva', href: '/Categoria/ropa' },
		// { icon: Package, label: 'Accesorios', href: '/Categoria/accesorios' },
		{
			icon: ClipboardList,
			label: 'Planes Personalizados',
			href: '/Categoria/planes-personalizados',
		},
		{ icon: FileText, label: 'Términos y Políticas', href: '/Terminos' },
	]

	return (
		<>
			<div
				className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity duration-300 lg:hidden ${
					isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
				} z-[9990]`}
				onClick={() => onClose?.()}
			/>

			<Box
				className={`fixed right-0 top-0 z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${
					isOpen ? 'translate-x-0' : 'translate-x-full'
				} z-[9991]`}
				style={{
					width: isOpen ? (window.innerWidth <= 768 ? '85%' : '400px') : '0px',
					maxWidth: '400px',
					height: '90vh',
					bottom: '10vh',
				}}
			>
				<div className='h-full bg-white shadow-2xl flex flex-col'>
					<div className='relative bg-gradient-to-r from-red-600 to-red-700 text-white p-6'>
						<button
							onClick={() => onClose?.()}
							className='absolute top-4 right-4 p-2 hover:bg-white/20 rounded-full transition-colors duration-200'
							aria-label='Cerrar menú'
						>
							<X size={24} />
						</button>

						<div className='flex items-center space-x-4 mt-2'>
							<div className='relative'>
								{customer?.images && customer.images.length > 0 ? (
									<img
										src={`${API_URL}/${customer.images[0].url}`}
										alt={`${customer?.name} ${customer?.lastname}`}
										className='w-16 h-16 rounded-full object-cover border-4 border-white shadow-lg'
									/>
								) : (
									<div className='w-16 h-16 rounded-full bg-gradient-to-br from-gray-600 to-gray-700 border-4 border-white shadow-lg flex items-center justify-center'>
										<span className='text-white font-bold text-lg'>
											{getInitials(
												customer?.name ?? 'U',
												customer?.lastname ?? 'S'
											)}
										</span>
									</div>
								)}
								<div className='absolute -bottom-1 -right-1 w-5 h-5 bg-green-400 border-2 border-white rounded-full'></div>
							</div>

							<div className='flex-1 min-w-0'>
								<h3 className='text-lg font-bold text-white truncate'>
									{customer
										? `${customer?.name} ${customer?.lastname}`
										: 'Usuario'}
								</h3>
								<div className='flex items-center space-x-2 mt-1'>
									<User size={14} className='text-white/80' />
									<span className='text-sm text-white/90'>Mi Perfil</span>
								</div>
							</div>
						</div>
					</div>

					{!customer && (
						<div className='p-4 bg-gray-50 border-b border-gray-200'>
							<div className='grid grid-cols-1 gap-3'>
								<Link
									to='/Registro'
									className='w-full bg-red-600 text-white font-semibold py-3 px-6 rounded-lg shadow-lg transition-all duration-200 hover:bg-red-700 hover:shadow-xl hover:-translate-y-0.5 active:bg-red-800 active:translate-y-0'
								>
									Registrarse
								</Link>
								<Link
									to='/Login'
									className='w-full bg-gray-800 text-white font-semibold py-3 px-6 rounded-lg shadow-lg transition-all duration-200 hover:bg-black hover:shadow-xl hover:-translate-y-0.5 active:bg-gray-900 active:translate-y-0'
								>
									Iniciar Sesión
								</Link>
							</div>
						</div>
					)}

					<nav className='flex-1 overflow-y-auto py-4'>
						<div className='space-y-1 px-3'>
							{menuItems.map((item, index) => {
								const IconComponent = item.icon
								return (
									<Link
										key={index}
										to={item.href}
										className='flex items-center space-x-4 px-4 py-3 mx-2 rounded-xl text-gray-700 hover:bg-red-50 hover:text-red-600 transition-all duration-200 group no-underline'
									>
										<div className='p-2 rounded-lg bg-gray-100 group-hover:bg-red-100 transition-colors duration-200'>
											<IconComponent
												size={20}
												className='text-gray-600 group-hover:text-red-600'
											/>
										</div>
										<span className='font-medium text-base'>{item.label}</span>
									</Link>
								)
							})}
							{customer && (
								<button
									onClick={() => onLogout?.()}
									className='w-full flex items-center space-x-4 px-4 py-3 mx-2 rounded-xl text-red-600 hover:bg-red-50 transition-all duration-200'
								>
									<div className='p-2 rounded-lg bg-red-100 hover:bg-red-200 transition-colors duration-200'>
										<LogOut size={20} className='text-red-600' />
									</div>
									<span className='font-medium text-base'>Cerrar Sesión</span>
								</button>
							)}
						</div>
					</nav>
				</div>
			</Box>
		</>
	)
}

export default MenuRight
